import { render, staticRenderFns } from "./TableCollapseActivities.vue?vue&type=template&id=975019a8&scoped=true"
import script from "./TableCollapseActivities.vue?vue&type=script&lang=js"
export * from "./TableCollapseActivities.vue?vue&type=script&lang=js"
import style0 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TableCollapseActivities.vue?vue&type=style&index=1&id=975019a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975019a8",
  null
  
)

export default component.exports